import React from 'react';
import { Box, Typography } from '@mui/material';

const Header = () => {
    return (
        <Box>
            <Typography variant="h6" textAlign="center" color="primary">
                What's the plan for today?
            </Typography>
        </Box>
    );
};

export default Header;